import { authConfig } from "../apiConfig";

// for get all logs
export const get_auditlog_with_pagination = async (data) => {
    try {
        const response = await authConfig.post(`activityHistory`, data, { headers: { "Content-Type": "multipart/form-data" } });
        // const response = await authConfig.post(`getCombinedActivityHistory`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response.data;
    } catch (error) {
        throw error;
    }
};